<template>
  <Affix>
    <Row class="mp_headerStyle">
      <i-col
        :xs="5"
        :sm="5"
        :md="5"
        :lg="5"
        :xl="4"
        :xxl="3"
        class="imgStyleContext"
      >
        <img src="static/image/icon-mpai-long-logo.png" class="imgStyle" />
      </i-col>
      <!-- <div class="diver">
        <div class="diverLine"></div>
      </div> -->
      <i-col span="14" class="mp_headerStyle_title">
        <Anchor :affix="false" show-ink>
          <AnchorLink href="#product_introduction" title="产品介绍" />
          <AnchorLink href="#target_audience" title="适用人群" />
          <AnchorLink href="#customer_case" title="客户案例" />
          <AnchorLink href="#customer_domain" title="正在使用" />
        </Anchor>
      </i-col>
      <i-col
        :xs="5"
        :sm="5"
        :md="5"
        :lg="5"
        :xl="3"
        :xxl="5"
        class="mp_headerStyle_right"
      >
        <router-link to="/download">
          <Button shape="circle">免费下载</Button>
        </router-link>
      </i-col>
    </Row>
  </Affix>
</template>
<script>
export default {
  methods: {}
};
</script>
<style>
.mp_headerStyle_title .ivu-anchor-wrapper {
  min-height: 62px;
  display: flex;
  float: left;
  margin-left: 7px;
}
.mp_headerStyle_title .ivu-anchor {
  display: flex;
  justify-content: end;
  align-items: center;
  font-weight: bold;
}
.mp_headerStyle_title .ivu-anchor-ink-ball {
  display: none;
}

.mp_headerStyle_title .ivu-anchor-link-active .ivu-anchor-link-title {
  padding: 10px 0;
  border-bottom: 2px solid #ffff;
}
@media screen and (min-width: 568px) {
  .mp_headerStyle_title .ivu-anchor-link .ivu-anchor-link-title {
    display: flex;
    justify-content: center;
    text-align: center;
    margin: 0 10px;
    font-size: 15px;
    color: white;
  }
  .mp_headerStyle_title .ivu-anchor-link {
    padding: 0 15px;
  }
  .mp_headerStyle_title .ivu-anchor-link-active > .ivu-anchor-link-title {
    color: #ffff;
    font-size: 15px;
  }
}
@media screen and (max-width: 568px) {
  .mp_headerStyle_title .ivu-anchor-link .ivu-anchor-link-title {
    display: flex;
    justify-content: center;
    text-align: center;
    margin: 0 5px;
    font-size: 12px;
    color: white;
  }
  .mp_headerStyle_title .ivu-anchor-link {
    padding: 0 5px;
  }
  .mp_headerStyle_title .ivu-anchor-link-active > .ivu-anchor-link-title {
    color: #ffff;
    font-size: 12px;
  }
}
.mp_headerStyle_title .ivu-anchor-link-active > .ivu-anchor-link-title:hover {
  font-size: 15px;
}
.mp_headerStyle_title .ivu-anchor-link-title {
  color: #ffff;
  font-size: 15px;
}
.mp_headerStyle_title .ivu-anchor-link-title:hover {
  font-size: 15px;
}
.mp_headerStyle_title .ivu-anchor-ink {
  position: relative;
  height: auto;
  left: auto;
  top: auto;
}
.mp_headerStyle_title .ivu-tabs-nav {
  margin: 0 20px;
}
.mp_headerStyle_title .ivu-tabs-nav .ivu-tabs-tab {
  color: #ffff;
  font-size: 15px;
  font-weight: bold;
  font-family: "微软雅黑";
  letter-spacing: 1px;
}
.mp_headerStyle_title .ivu-tabs-nav .ivu-tabs-tab:hover {
  color: #ffff;
}
.mp_headerStyle_title .ivu-tabs-ink-bar {
  background-color: #ffff;
}
.mp_headerStyle_title .ivu-tabs-bar {
  border-bottom: none;
  margin-bottom: 0;
}
.mp_headerStyle_right .ivu-btn {
  color: #28aae2;
}
</style>
<style lang="less" scoped>
@media screen and (min-width: 568px) {
  .mp_headerStyle {
    padding: 0 50px;
  }
  .imgStyleContext {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    min-height: 62px;
    .imgStyle {
      width: 90%;
    }
  }
}
@media screen and (max-width: 568px) {
  .mp_headerStyle {
    padding: 0 40px;
  }
  .imgStyleContext {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    min-height: 62px;
    .imgStyle {
      width: 100%;
    }
  }
}
// @media screen and (min-width: 1200px) {
.mp_headerStyle {
  min-height: 62px;
  background: #28aae2;
  z-index: 2;
  .mp_headerStyle_right {
    min-height: 61px;
    float: right;
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }
  .mp_headerStyle_title {
    min-height: 62px;
    min-width: 280px;
    float: left;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    .mp_headerStyle_title_menu {
      display: flex;
      float: left;
      .mp_headerStyle_title_menu_item {
        width: 100px;
        text-align: center;
        padding-left: 10px;
        font-size: 14px;
        color: #ffff;
        font-family: "微软雅黑";
        border-bottom: 1px solid #ffff;
        transition: 0.2s all linear;
      }
    }
  }
}
// }

// @media screen and (max-width: 568px) {
//   .mp_headerStyle_right {
//     display: none !important;
//     height: 0px !important;
//     background: chocolate;
//   }
// }

// @media screen and (max-width: 993px) {
//   .diver {
//     display: inherit;
//     width: 100%;
//     display: flex;
//     justify-content: center;
//     .diverLine {
//       display: inherit;
//       height: 0.1px;
//       width: 90%;
//       background: #ffff;
//     }
//   }
// }
</style>
